<template>
  <div class="form-group" :class="{'input-box': showInputBox}">

    <div class="form-check">
      <label class="form-check-label" :for="getFieldName" :class="{ 'text-danger': hasErrors(getFieldName) }">

        <input class="form-check-input"
               type="checkbox"
               v-model.lazy="inputVal"
               :name="getFieldName"
               :id="getFieldName"
               :data-vv-as="label"
               v-validate.immediate="vvalidate"
               v-bind="$attrs"
               :disabled="isReadOnly || disabled">
        {{label}}
        <i v-if="addEmailNotification"
           class="glyphicon glyphicon-envelope"
           v-tooltip="'Email might be generated'"
           title="Email might be generated">
        </i>
      </label>
      <br>
      <small class="form-text text-muted" v-if="subtext">
        {{subtext}}
      </small>
    </div>

    <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span v-for="(error, index) in errorsFor(getFieldName)" class="text-danger" :key="`error_${getFieldName}_${index}`">
        {{error}}
      </span>
    </div>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'CheckBox',
  mixins: [CustomInputMixin],
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}

input[type=checkbox]:hover, label:hover {
  cursor: pointer
}
</style>
